import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LoginSessionResponse} from "../types/login-session-response";


@Injectable({
    providedIn: 'root',
})
export class BffService {

    private readonly http = inject(HttpClient);

    private loginVerificationUrl = '/apis/login-verification';

    verifyLogin(
        userToken: string,
    ): Observable<LoginSessionResponse> {
        const headers: {
            authorization: string;
            'Content-Type': string;
            'Accept': string;
        } = {
            authorization: `bearer ${userToken}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };

        return this.http.post<LoginSessionResponse>(this.loginVerificationUrl, null, {
            headers: headers,
        });
    }
}
